// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  main_url: 'https://gatewaystaging.wenjoy.com.co/api/1.0/',
  document_types: [
    {value: 1, name: 'Cedula de ciudadania'},
    {value: 2, name: 'NIT'},
    {value: 3, name: 'Cedula de extranjería'},
    {value: 4, name: 'Pasaporte'},
  ],
  pse_payment_method: 4,
  card_payment_method: 5,
  zona_pagos_url_pse: 'https://www.zonapagos.com/t_armatuvacapas/pago.asp?estado_pago=iniciar_pago&identificador=',
  card_types: [
    {value: 1, name: 'visa'},
    {value: 2, name: 'mastercard'},
    {value: 4, name: 'dinersclub'},
    {value: 5, name: 'amex'}
  ],
  card_default_type: 3,
  participation_link: 'https://gatewaystaging.wenjoy.com.co/participate/',
  states_payment: {
    APPROVED: 1,
    SENDED_FRONT: 100,
    FINISHED: 101,
    TIMEOUT: 102,
    TIMEOUT_CODE_0: 103,
    PENDING_BEGGINING: 888,
    PENDING_FINISH: 999,
    REJECTED: 1000,
    REJECTED_CR: 4000,
    PENDING_FRAUD: 4001
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts